import {
  EMAIL_RESPONSE_LIST_REQUEST,
  EMAIL_RESPONSE_LIST_RECEIVED,
  EMAIL_RESPONSE_LIST_ERROR,
  EMAIL_RESPONSE_LIST_UNLOAD,
  EMAIL_RESPONSE_LIST_SET_PAGE,
  EMAIL_RESPONSE_LIST_SET_FILTERS,
  EMAIL_RESPONSE_LIST_CLEAR_FILTERS,
  EMAIL_RESPONSE_SINGLE_UPDATED,
} from '../constants';

import { hydraPageCount } from '../../helper/apiUtils';

const reducer = (
  state = {
    emailResponses: [],
    pageCount: null,
    currentPage: 1,
    isFetchingEmailResponses: false,
    filters: {},
  },
  action,
) => {
  switch (action.type) {
    case EMAIL_RESPONSE_LIST_REQUEST:
      return {
        ...state,
        isFetchingEmailResponses: true,
      };
    case EMAIL_RESPONSE_SINGLE_UPDATED:
      let mergedEmailResponses = [...state.emailResponses.filter((a) => a.id !== action.data.id), action.data];
      return {
        ...state,
        emailResponses: mergedEmailResponses,
        pageCount: hydraPageCount(action.data),
        isFetchingEmailResponses: false,
      };

    case EMAIL_RESPONSE_LIST_RECEIVED:
      let emailResponses = action.data['hydra:member'];
      if (action.append) {
        const mergedEmailResponses = [...state.emailResponses, ...action.data['hydra:member']];
        emailResponses = Array.from(new Set(mergedEmailResponses.map((a) => a['@id']))).map((id) => {
          return mergedEmailResponses.find((a) => a['@id'] === id);
        });
      }

      // Extract current page from hydra view data
      const currentPage =
        action.data['hydra:view'] && action.data['hydra:view']['@id']
          ? parseInt(new URL(action.data['hydra:view']['@id'], 'http://dummy').searchParams.get('page')) || 1
          : 1;

      return {
        ...state,
        emailResponses,
        pageCount: hydraPageCount(action.data),
        currentPage,
        isFetchingEmailResponses: false,
      };

    case EMAIL_RESPONSE_LIST_ERROR:
      return {
        ...state,
        isFetchingEmailResponses: false,
      };

    case EMAIL_RESPONSE_LIST_UNLOAD:
      return {
        emailResponses: [],
        pageCount: null,
        currentPage: 1,
        isFetchingEmailResponses: false,
        filters: {},
      };

    case EMAIL_RESPONSE_LIST_SET_PAGE:
      return {
        ...state,
        currentPage: action.page,
      };

    case EMAIL_RESPONSE_LIST_SET_FILTERS:
      return {
        ...state,
        filters: action.filters,
      };

    case EMAIL_RESPONSE_LIST_CLEAR_FILTERS:
      return {
        ...state,
        filters: {},
      };

    default:
      return state;
  }
};

export default reducer;
